import { createColorKeys } from '~/utils/chakraUtils'

// This is referenced in src/themes/colors/colors.ts
export const voicemailColors = {
  Voicemail: {
    // Color file references go here
  },
}

export const voicemailColorKeys = createColorKeys(voicemailColors)
